module.exports = __webpack_public_path__ + "static/media/arrow-angle-right-red.be45136b.svg";